if (!customElements.get("cart-notification-remove-button")) {
    class CartNotificationRemoveButton extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("click", (event) => {
          event.preventDefault();
        });
      }
    }
  
    customElements.define(
      "cart-notification-remove-button",
      CartNotificationRemoveButton
    );
  }
  
  if (!customElements.get("cart-notification-product")) {
    class CartNotificationProduct extends HTMLElement {
      constructor() {
        super();
        this.onRemove = this.onRemove.bind(this);
        this.onQuantityChange = this.onQuantityChange.bind(this);
  
        this.cartNotification = document.querySelector("cart-notification");
  
        this.removeButton = this.querySelector("cart-notification-remove-button");
        this.removeButton.addEventListener("click", this.onRemove);
  
        this.quantityInput = this.querySelector("quantity-input");
        this.quantityInput.addEventListener("change", this.onQuantityChange);
        
      
      }
   
      onQuantityChange() {
        this.setQuantity(this.quantityInput.getValue());
      }
  
      onRemove() {
        this.setQuantity(0);
      }
      
      setQuantity(value) {
        const payload = {};
        payload.updates = {};
        payload.updates[this.dataset.variantId] = value;
        
        payload.sections = this.cartNotification
          .getSectionsToRender()
          .map((section) => section.id);
        payload.sections_url = window.location.pathname;
        
        return fetch(routes.cart_update_url, {
          ...fetchConfig(),
          body: JSON.stringify(payload),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
            
            this.cartNotification.renderContents(response);
          });
      }
  
      handleErrorMessage(errorMessage = false) {
        console.errror("Error updating product item", errorMessage);
      }
  
      disconnectedCallback() {
        this.removeButton.removeEventListener("click", this.onRemove);
        this.quantityInput.removeEventListener("change", this.onQuantityChange);
      }
    }
  
    customElements.define("cart-notification-product", CartNotificationProduct);
  }
  
  if (!customElements.get("cart-notification")) {
    class CartNotification extends HTMLElement {
      constructor() {
        super();
  
        this.notification = document.getElementById("cart-notification");
  
        this.items = this.notification.querySelector(
          "[data-cart-notification-items]"
        );
  
        
  
        this.header = document.querySelector("sticky-header");
        this.container = this.querySelector("[data-cart-notification-container]");
        this.summary = this.querySelector("[data-cart-notification-summary]");
        this.mainContent = this.querySelector("[data-cart-notification-main]");
       
        this.onBodyClick = this.handleBodyClick.bind(this);  
        
        this.notification.addEventListener(
          "keyup",
          (evt) => evt.code === "Escape" && this.close()
        );
        this.addEventListener("click", (event) => {
            if(event.target.classList.contains('td-cart-related-products__card-atc')) {
              this.onQuickAdd(event)
            }
        })
        this.querySelectorAll("[data-cart-notification-close-button]").forEach(
          (closeButton) =>
            closeButton.addEventListener("click", this.close.bind(this))
        );
      }
      onQuickAdd = (event) => {
        let formData = {
          'items': [{
           'id': event.target.dataset.product,
           'quantity': 1
           }]
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
          })
          .then(response => {   
              
              return response.json();
          })
          .then(res => {
           this.reRenderCart(res.items[0].id,1)           
          })
          .catch((error) => {
              console.error('Error:', error);
          })
      }
      
      reRenderCart(productId,value) {
        const payload = {};
        payload.updates = {};
        payload.updates[productId] = value;
        payload.sections = this.getSectionsToRender().map((section) => section.id);
        return fetch(routes.cart_update_url, {
          ...fetchConfig(),
          body: JSON.stringify(payload),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }            
            this.renderContents(response);
            
          });
      }
      
      open() {
        const openCart = new Event('open-cart'); document.dispatchEvent(openCart);
        console.debug("Open cart drawer");
        this.updateOverlayState();

        this.notification.classList.add("animate", "active");
  
        if (window.innerWidth <= 749) {
          document.body.classList.add("overflow-hidden-tablet");
        }
  
        this.notification.addEventListener(
          "transitionend",
          () => {
            this.notification.focus();
            trapFocus(this.notification);
          },
          { once: true }
        );
        document.querySelector('.mini-cart-overlay').classList.add('display-overlay')
        document.body.addEventListener("click", this.onBodyClick);
        
      }
  
      close() {
        console.debug("Close cart drawer");
        document.body.classList.remove("overflow-hidden-tablet");
        this.notification.classList.remove("active");
        document.querySelector('.mini-cart-overlay').classList.remove('display-overlay')
        document.body.removeEventListener("click", this.onBodyClick);      
        const htmlSelector = document.querySelector('html')
        htmlSelector.classList.remove('menu-drawer-open')
        htmlSelector.classList.remove('mini-cart-open')
        removeTrapFocus(this.activeElement);
      }
  
      renderContents(parsedState) {
        this.productId = parsedState.id;
        this.recommendedProducts = this.querySelector("[data-cart-recommended-products]");
        
        this.getSectionsToRender().forEach((section) => {
          try {
            document.getElementById(section.id).innerHTML =
              this.getSectionInnerHTML(
                parsedState.sections[section.id],
                section.selector
              );
          } catch (e) {
            if (section.id != "cart-count") {
              throw e;
            }
          }
        });
  
        this.recommendedProducts = document.querySelector("[data-cart-recommended-products]");
      
          if(this.recommendedProducts) {
            const renderCart = new Event('render-cart'); 
            this.recommendedProducts.dispatchEvent(renderCart);
          }
        this.open();
      }
  
      updateOverlayState() {
        const hasScrollableContent =
          this.items.scrollHeight > this.items.clientHeight;
  
        if (hasScrollableContent) {
          this.container.classList.add("js-overlay-state");
        } else {
          this.container.classList.remove("js-overlay-state");
        }
      }
  
      getSectionsToRender() {
        return [
          {
            id: "td-cart-notification-product",
          },
          {
            id: "cart-icon-bubble",
          },
          {
            id: "td-cart-count",
          },
          {
            id: "td-cart-notification-summary",
          },
          {
            id: "td-cart-related-products",
          }
        ];
      }
  
      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }
  
      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target !== this.notification &&
          !target.closest("cart-notification")
        ) {
          const disclosure = target.closest("details-disclosure");
          this.activeElement = disclosure
            ? disclosure.querySelector("summary")
            : null;
          this.close();
        }
      }
  
      setActiveElement(element) {
        this.activeElement = element;
      }
    }
  
    customElements.define("cart-notification", CartNotification);
  }
  